//Polyfills
import 'core-js/stable';
import 'regenerator-runtime/runtime';

import React from 'react';

//Library styles
import './styles/vendor/flexboxgrid.css';

import './index.html';
import './styles/styles.scss';
import 'react-virtualized/styles.css';

// Modules
import Root from 'components/Root';

import 'mobx-react/batchingForReactDom';
import ReactDOM from 'react-dom/client';

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container as Element);

root.render(<Root />);
